<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp" id="ep"> </p>
<p class="FM-Epigraph-non-verse-fmepi"><span epub:type="pagebreak" id="pg_7" title="7">The end is simply the beginning of a longer story.</span></p>
<p class="FM-Epigraph-Source-fmeps">—<span class="ePub-I">Zadie Smith</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?68c77398